import { FC } from "react";
import SimpleDropdown from "../simple-dropdown";
import { getArrayOfValuesFromArray } from "lib/utils/array-utils";
import { ALL_CLINIC_OPTION } from "lib/constants";

interface ClinicsDropdownProps {
  label?: string;
  clinics: Clinic[];
  selectedClinic: Clinic | null;
  onSelect: (clinic: Clinic) => void;
  className?: string;
  parentClassName?: string;
  isShowAll?: boolean;
}

/**
 * ClinicsDropdown component allows users to select a clinic from a dropdown list.
 *
 */
const ClinicsDropdown: FC<ClinicsDropdownProps> = ({
  label = "Clinics",
  clinics,
  onSelect,
  selectedClinic,
  className,
  parentClassName,
  isShowAll = false,
}) => {
  const clinicsWithAllOption = isShowAll
    ? [ALL_CLINIC_OPTION, ...clinics]
    : clinics;

  const clinicOptions = getArrayOfValuesFromArray(clinicsWithAllOption, "name");
  const clinicValues = getArrayOfValuesFromArray(clinicsWithAllOption, "id");

  return (
    <SimpleDropdown
      parentClassName={`mb-0 ${parentClassName}`}
      label={label}
      className={`simple-dropdown ${className}`}
      options={Array.from(new Set(clinicOptions))}
      selectedValue={selectedClinic?.id}
      values={Array.from(new Set(clinicValues))}
      onSelectValue={(value) => {
        const selectedClinic = clinicsWithAllOption.find(
          (clinic) => clinic.id === value
        );
        if (selectedClinic) {
          onSelect(selectedClinic);
        }
      }}
    />
  );
};
export default ClinicsDropdown;
